import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Select, MenuItem } from "@material-ui/core";
import { LANGUAGES } from '../config/config';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        margin: 0,
        padding: 0,
        backgroundColor: '#0C0C0C',
    },
    content: {
        paddingRight: 10,
        paddingLeft: 10,
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
    },
    suiteBar: {
        marginRight: 10,
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: '100%',
        },
        paddingLeft: '10px',
        paddingRight: '10px',
        background: '#F1F1F1 0% 0% no-repeat padding-box',
    },
    root: {
        "& .MuiSelect-root": {
            boxShadow: "0px 3px 3px #0000001A",
            borderRadius: "10px",
            opacity: 1,
            margin: 2,
            paddingRight: 0,
        },
        "& .MuiSelect-icon": {
            color: '#EDEDED',
        },
        "& .MuiSelect-root.Mui-selected": {
            border: 'none',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        "&&&:before": {
            borderBottom: "none",
        },
        "&&:after": {
            borderBottom: "none",
        },
    },
    select: {
        '&:hover': {
            backgroundColor: '#3F4849',
            borderRadius: '20px',
            paddingLeft: '5px',
            paddingRight: '5px',
            marginRight: '-5px',
        },
    },
    menuPaper: {
        marginTop: '37px',
        marginLeft: '-38px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
        background: '#141D1E',
    },
    menuItem: {
        color: '#BEC8C9',
        '&:hover': {
            color: '#E1FF2B',
        },
        '&.Mui-selected': {
            color: '#E1FF2B',
        },
    },
}));

const Header = () => {

    const [, i18n] = useTranslation("global");
    const classes = useStyles();

    const onChangeLang = (e) => {
        const lang_code = e.target.value;
        i18n.changeLanguage(lang_code);
        localStorage.setItem('bms_lang', JSON.stringify(lang_code));
        sessionStorage.removeItem('versionApp');
    };

    const getFlagSrc = (lang) => {
        return LANGUAGES.filter((arr) => arr.code === lang)[0];
    };

    useEffect(() => {
        const pathname = window.location.pathname.toLowerCase();
        if (pathname === '/resetpassword') {
            const searchParams = new URLSearchParams(window.location.search);
            const lang = searchParams.get('lang')?.toLowerCase();
            if (lang) {
                localStorage.setItem('bms_lang', JSON.stringify(lang));
                i18n.changeLanguage(lang);
            }
        }
    }, [i18n]);
    

    return (
        <>
            <AppBar position={'static'} style={{ zIndex: 1211 }}>
                <Toolbar className={classes.toolbar}>
                    <Grid container>
                        <Grid item xs={false} sm={1} />
                        <Grid item xs={12} sm={10} className={classes.content}>
                            <Box display="flex" alignItems="center">
                                <Select
                                    className={classes.root}
                                    classes={{ select: classes.select }}
                                    value={i18n.language}
                                    onChange={onChangeLang}
                                    renderValue={(selected) => {
                                        const flagSrc = getFlagSrc(selected);
                                        return (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', paddingRight: '32px' }}>
                                                <img src={flagSrc?.img} alt="language" style={{ width: '28px', height: '28px' }} />
                                                <p style={{ margin: 0, lineHeight: 'normal', color: '#EDEDED', fontSize: '14px', marginTop: '4px' }}>{flagSrc?.code.toUpperCase()}</p>
                                            </div>
                                        );
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            className: classes.menuPaper,
                                        },
                                    }}
                                >
                                    {LANGUAGES.map(({ code, label, img }) => (
                                        <MenuItem
                                            className={classes.menuItem}
                                            key={code}
                                            value={code}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                                <img
                                                    src={img}
                                                    alt="language"
                                                    style={{ width: '24px', height: 'auto', marginLeft: '8px' }}
                                                />
                                                <span style={{ lineHeight: 'normal', marginTop: '4px' }}>{code.toUpperCase()} - {label}</span>
                                            </div>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                        </Grid>
                        <Grid item xs={false} sm={1} />
                    </Grid>
                </Toolbar>
            </AppBar>
        </>
    );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
